export default __webpack_public_path__ + "fonts/89f44e00f6dae0790221229c2d45a61b.svg";